import {
  DATA_PRIVACY_FORM_FIELDS,
  DPR_API_URL,
  PRIVACY_REQUESTS,
} from 'site-modules/data-privacy-request/constants/constants';
import { VisitorModel } from 'client/data/models/visitor';
import { UserProfileModel } from 'client/data/models/profile/profile';
import { IDM_METHODS } from 'client/data/models/profile/profile-constants';
import { appendSubmitQueryParam } from 'site-modules/data-privacy-request/utils/query-params';
// eslint-disable-next-line venom/no-venom-api-calls
import { externalDataAPI, VenomApi } from 'client/data/api/api-client';
import { objectToQueryString } from 'site-modules/shared/utils/string';

const updatePrivacySettings = async (requestType, setModelValue, isAuthenticated) => {
  if (requestType === PRIVACY_REQUESTS.CCPA_OPT_OUT_SALE_PI) {
    if (isAuthenticated) {
      await setModelValue('data.idm', UserProfileModel, {
        data: {
          meta: { preventThirdPartySharing: true },
        },
        method: IDM_METHODS.UPDATE,
      });
    } else {
      await setModelValue('privacy', VisitorModel, { doNotSell: true });
    }
  }
};

const removeCookie = async requestType => {
  if (requestType !== PRIVACY_REQUESTS.CCPA_DELETE_PI) {
    return;
  }

  // eslint-disable-next-line venom/no-venom-api-calls
  const response = await VenomApi.fetch('/ccpa/remove', {
    method: 'GET',
    credentials: 'same-origin',
  });

  if (response && response.status === 200) {
    appendSubmitQueryParam(window.location);
    window.location.reload();
    return;
  }

  throw Error(response.statusText);
};

const submitFormData = async fields => {
  const options = {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: objectToQueryString(fields),
    showAPIError: true,
  };

  const response = await externalDataAPI(DPR_API_URL).fetch('/sendRequest', options);

  if (response && response.status === 200) {
    return;
  }

  throw Error(response.statusText);
};

export const submitDataPrivacyRequest = async ({ fields, setModelValue, isAuthenticated }) => {
  await updatePrivacySettings(fields[DATA_PRIVACY_FORM_FIELDS.REQUEST_TYPE], setModelValue, isAuthenticated);
  await submitFormData(fields);
  await removeCookie(fields[DATA_PRIVACY_FORM_FIELDS.REQUEST_TYPE]);
};
